import {device, platform} from 'c-nenv';
import {serviceFactory} from './component/api';

// 配置相关的service
// localStorage.clear();
// UG挂载ajaxBuilder

//  快捷方式
export const giftService = serviceFactory('universal-gift');
export const ugMallService = serviceFactory('mall');
export const ugRankingService = serviceFactory('ranking');
export const giftMallService = serviceFactory('gifto_mall');

export const config = {
    device: device,
    platform: platform,
    isIOS: device.isIOS,
    isAndroid: device.isAndroid,
    // 这个https不支持
    appDownloadPage: 'http://h5.upliveapp.com/uppro/download.html',
    // TODO 看看到底有没有用到的
    appApkDownloadLink: 'https://n.pengpengla.com/android/Uplive_2017.12.29_2.7.2_10523.production_upliveV1UpDomesticLocalDevelop.apk',
    appQqDownloadLink: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.asiainno.uplive',
    publishUrl: location.origin + location.pathname
};

export const urls = {
    facebook: 'https://www.facebook.com',
    instagram: 'https://www.instagram.com',
    youtube: 'https://www.youtube.com'
};

export const blockChainGiftId = {
    // 2018、11、09修改了@ming
    // stage: 12345678,
    stage: 999999999,
    pro: 999999999
};



// WEBPACK FOOTER //
// ./js/config.js